<script>
// import Swiper JS
import Swiper from "swiper";
// import Swiper styles
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation, Pagination } from "swiper/core";

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination]);
export default {
  name: "quem-somos",
  data() {
    return {};
  },
  mounted() {
    var swiper = new Swiper(this.$refs["mySwiper"], {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: this.$refs["swiper-pagination"],
        clickable: true,
      },
      navigation: {
        nextEl: this.$refs["swiper-button-next"],
        prevEl: this.$refs["swiper-button-prev"],
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });
    var swiper = new Swiper(this.$refs["mySwiper2"], {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: this.$refs["swiper-pagination2"],
        clickable: true,
      },
      navigation: {
        nextEl: this.$refs["swiper-button-next2"],
        prevEl: this.$refs["swiper-button-prev2"],
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
      },
    });
  },
  components: {},
  computed: {
    ourAreas() {
      return this.$store.state.ourAreas;
    },
  },
};
</script>

<template>
  <div class="who-we-are" id="quem-somos">
    <section class="container">
      <header>
        <h2>Quem Somos</h2>
        <p>
          A TotalPass é um benefício corporativo que conecta os colaboradores de
          várias empresas às melhores academias e estúdios do Brasil.
          <br /><br />
          Buscamos descomplicar a rotina das pessoas oferecendo uma nova
          experiência ao praticar atividade física e ser a marca referência em
          qualidade para o cliente nesse setor.
        </p>
      </header>
    </section>
    <section class="container who-we-are__values">
      <header>
        <h2>Valores</h2>
      </header>
      <div class="row">
        <div class="col-lg-6">
          <span> PROPÓSITO </span>
          <p>Descomplicar a rotina das pessoas</p>
        </div>
        <div class="col-lg-6">
          <span> Missão </span>
          <p>
            Ser a marca referência em qualidade para <br />
            o cliente nesse setor.
          </p>
        </div>
      </div>
    </section>
    <section class="container who-we-are__combined">
      <span>COMBINADOS</span>
      <div class="swiper-container mySwiper" ref="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="here-card">
              <div class="img">
                <img
                  src="@/assets/images/totalpass/foto-transparencia.jpg"
                  alt=""
                />
              </div>
              <div class="text">
                <h4>TRANSPARÊNCIA</h4>
                <p>
                  Somos sinceros e claros em nossas abordagens. Estabelecemos
                  uma relação de confiança e respeito com as pessoas com quem
                  nos relacionamos.
                </p>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="here-card">
              <div class="img">
                <img
                  src="@/assets/images/totalpass/foto-time-de-donos.jpg"
                  alt=""
                />
              </div>
              <div class="text">
                <h4>TIME DE DONOS</h4>
                <p>
                  Acreditamos no negócio, vestimos a camisa e desejamos ver a
                  empresa prosperar como um todo. Estamos comprometidos com a
                  entrega do resultado. Nos interessamos por outras áreas, não
                  apenas a qual estou.
                </p>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="here-card">
              <div class="img">
                <img
                  src="@/assets/images/totalpass/foto-data-driven.jpg"
                  alt=""
                />
              </div>
              <div class="text">
                <h4>DATA DRIVEN</h4>
                <p>
                  Temos coragem de nos expor e falar o que sentimos. Opinamos
                  nosso ponto de vista, compartilhamos nossas ideias e
                  contribuímos com o todo.
                </p>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="here-card">
              <div class="img">
                <img src="@/assets/images/totalpass/foto-voz.png" alt="" />
              </div>
              <div class="text">
                <h4>VOZ</h4>
                <p>
                  Temos coragem de nos expor e falar o que sentimos. Opinamos
                  nosso ponto de vista, compartilhamos nossas ideias e
                  contribuímos com o todo.
                </p>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="here-card">
              <div class="img">
                <img
                  src="@/assets/images/totalpass/foto-divertido.png"
                  alt=""
                />
              </div>
              <div class="text">
                <h4>DIVERTIDO</h4>
                <p>
                  Contribuímos para tornar o ambiente descontraído e divertido.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-prev" ref="swiper-button-prev"></div>
        <div class="swiper-button-next" ref="swiper-button-next"></div>
        <div class="swiper-pagination" ref="swiper-pagination"></div>
      </div>
    </section>
    <section class="who-we-are__areas">
      <div class="container">
        <header>
          <h2>Nossas áreas</h2>
        </header>
        <div
          class="
            who-we-are__areas__row
            d-flex
            justify-content-between
            justify-content-md-center
            justify-content-lg-between
            flex-wrap
          "
        >
          <div
            class="who-we-are__areas__row__col"
            v-for="(area, index) in ourAreas"
            :key="index"
          >
            <div class="who-we-are__areas__row__col__box">
              <div class="img">
                <img
                  :src="require(`@/assets/images/totalpass/${area.icon}`)"
                  :alt="area.title"
                />
              </div>
              <span>
                {{ area.title }}
              </span>
            </div>
          </div>
        </div>
        <button
          @click="$router.push({ name: 'jobs' })"
          class="btn btn-primary btn-view"
        >
          Ver oportunidades
        </button>
      </div>
    </section>
    <section class="who-we-are__work-here">
      <div class="container">
        <h2>Como é trabalhar aqui</h2>
      </div>
      <div class="bg">
        <div class="container">
          <div class="swiper-container mySwiper mySwiper2" ref="mySwiper2">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="here-card">
                  <div class="img">
                    <img
                      src="@/assets/images/totalpass/foto-carolina-soares.jpg"
                      alt=""
                    />
                  </div>
                  <div class="text">
                    <p>
                      Fazer parte da TotalPass me traz uma gratidão imensa!
                      Cresci pessoal e profissionalmente aqui dentro, gosto de
                      como somos desafiados a cada dia para sermos melhores,
                      vencer obstáculos e buscar sonhos! Tenho muita admiração e
                      orgulho das pessoas que trabalham comigo. Além disso, os
                      combinados que temos me faz ter sentir que juntos iremos
                      muito mais longe e é o que alimenta a minha paixão pela
                      TotalPass."
                    </p>
                    <span class="cargo">
                      <strong> Carolina Soares </strong>
                      Analista de Relacionamento
                    </span>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="here-card">
                  <div class="img">
                    <img
                      src="@/assets/images/totalpass/foto-gustavo-cardoso.jpg"
                      alt=""
                    />
                  </div>
                  <div class="text">
                    <p>
                      Trabalhar na TotalPass, pra mim, é ser desafiado todos os
                      dias. Quando entrei na empresa, sabia o tamanho do desafio
                      e hoje, quase 2 anos depois, vejo quanto pude contribuir
                      para o desenvolvimento da companhia e do departamento em
                      que atuo. <br />
                      <br />
                      Tenho um prazer enorme por trabalhar aqui, com pessoas
                      incríveis, que me ajudam a crescer todos os dias.
                    </p>
                    <span class="cargo">
                      <strong> Gustavo Cardaci </strong>
                      Analista de Marketing
                    </span>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="here-card">
                  <div class="img">
                    <img
                      src="@/assets/images/totalpass/foto-carolina-soares.jpg"
                      alt=""
                    />
                  </div>
                  <div class="text">
                    <p>
                      Fazer parte da TotalPass me traz uma gratidão imensa!
                      Cresci pessoal e profissionalmente aqui dentro, gosto de
                      como somos desafiados a cada dia para sermos melhores,
                      vencer obstáculos e buscar sonhos! Tenho muita admiração e
                      orgulho das pessoas que trabalham comigo. Além disso, os
                      combinados que temos me faz ter sentir que juntos iremos
                      muito mais longe e é o que alimenta a minha paixão pela
                      TotalPass."
                    </p>
                    <span class="cargo">
                      <strong> Carolina Soares </strong>
                      Analista de Relacionamento
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-button-prev sp2" ref="swiper-button-prev2"></div>
            <div class="swiper-button-next sn2" ref="swiper-button-next2"></div>
            <div class="swiper-pagination2 sw2" ref="swiper-pagination2"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
.who-we-are__combined {
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: -3rem;
  }
  .swiper-pagination-bullet-active {
    background: theme-color(primary) !important;
  }
}

.who-we-are__work-here {
  position: relative;
  .bg {
    padding-bottom: 5rem;
    position: relative;
  }
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 2rem;
    left: 0;
    right: 0;
    position: absolute;
    margin: 0 auto;
    text-align: center;
  }
  .swiper-pagination-bullet-active {
    background: #fff !important;
  }
}
</style>

<style lang="scss" scoped>
.who-we-are {
  font-family: "Poppins", sans-serif;

  .mySwiper2 {
    margin-top: -5rem;
    .swiper-slide {
      box-shadow: 0px 5px 16px #00000029;
      border-radius: 7px;
      overflow: hidden;
      .here-card {
        display: flex;
        @include media-breakpoint-down(md) {
          flex-direction: column;
        }
        .text {
          background-color: #fff;
          padding: 2rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          p {
            font-size: 1.3rem;
            line-height: calc(1.3rem * 1.5);
          }
          span {
            font-size: 1.3rem;
            strong {
              color: theme-color(primary);
              display: block;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
  &__work-here {
    padding: 4rem 0px;
    margin-top: 4rem;
    .bg {
      background-color: theme-color(primary);
      width: 100%;
      position: relative;
      margin-top: 4rem;
      border-top: 4.5rem solid #fff;
      height: auto;
      .img {
        @include media-breakpoint-down(md) {
          height: 400px;
          overflow: hidden;
        }
      }
      img {
        width: auto;
        max-width: 2000px;
        height: 600px;
        @include media-breakpoint-down(md) {
          height: auto;
          width: 100%;
          max-height: 2600px;
        }
      }
    }
  }

  .swiper-container {
    padding-bottom: 2rem;
  }
  h2 {
    margin-bottom: 1.5rem;
  }
  header {
    margin-top: 6rem;
  }
  @include media-breakpoint-down(md) {
    text-align: center;
    header {
      margin-top: 3rem;
    }
    h2 {
      margin-bottom: 1rem;
    }
  }
  &__values,
  &__combined {
    h2 {
      margin-bottom: 3.5rem;
    }
    span {
      font-size: 1.4rem;
      text-transform: uppercase;
      color: theme-color(dark);
      font-weight: bold;
      background-color: theme-color(primary);
      padding: 5px 1rem;
      position: relative;
      font-family: "Poppins", sans-serif;
      &::after {
        content: "";
        right: -8px;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 50px solid #fff;
        position: absolute;
        bottom: 0px;
      }
      &::before {
        content: "";
        left: -10px;
        border-left: 0px solid transparent;
        border-right: 15px solid #fff;
        border-bottom: 50px solid #fff;
        position: absolute;
        bottom: 0px;
        transform: skew(-10deg);
      }
    }
    p {
      margin-top: 1rem;
    }
  }
  &__combined {
    font-family: "Poppins", sans-serif;
    span {
      margin-bottom: 3rem;
    }
    .here-card {
      margin-top: 2rem;
      box-shadow: 0px 5px 16px #00000029;
      border-radius: 7px;
      .text {
        padding: 2rem 2rem 1rem 2rem;
        min-height: 300px;
        h4 {
          font-weight: bold;
        }
      }
    }
    p {
      font-size: 1.1rem;
      line-height: calc(1.1rem * 1.9);
    }
  }

  &__areas {
    background-color: rgba(#080808, 0.06);
    padding: 4rem 0px;
    margin-top: 5rem;
    display: block;
    h2,
    header {
      margin: 0px;
      padding: 0px;
    }
    h2 {
      margin-bottom: 3rem;
    }
    &__row {
      &__col {
        width: calc(20% - 4rem);
        margin: 1rem 2rem 1.8rem 0px;

        &:nth-child(5n) {
          margin-right: 0rem;
          margin-left: 0rem;
        }
        @include media-breakpoint-down(md) {
          width: calc(33% - 4rem);
          &:nth-child(5n) {
            margin-right: 2rem;
            margin-left: 0rem;
          }
          &:nth-child(3n) {
            margin-right: 0rem;
            margin-left: 0rem;
          }
        }
        @include media-breakpoint-down(sm) {
          width: calc(50% - 1rem);
          &:nth-child(5n) {
            margin-right: 0rem;
            margin-left: 0rem;
          }
          &:nth-child(3n) {
            margin-right: 0rem;
            margin-left: 0rem;
          }
          &:nth-child(2n) {
            margin-right: 0rem;
            margin-left: 0rem;
          }
        }
        &__box {
          width: 100%;
          .img {
            width: 100%;
            background-color: #fff;
            box-shadow: 0px 5px 16px #00000029;
            border-radius: 7px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 3rem 0px;
            img {
              height: 75px;
            }
          }
          span {
            width: 100%;
            text-align: center;
            font-weight: 700;
            color: #080808;
            display: block;
            font-size: 1.5rem;
            margin-top: 1.3rem;
            @include media-breakpoint-down(sm) {
              font-size: 1.2rem;
            }
          }
        }
      }
    }
    .btn-view {
      margin: 0px auto;
      display: block;
      font-size: 1.4rem;
      font-weight: 500;
      padding: 0.5rem 3rem;
      margin-top: 3rem;
    }
  }
}
</style>

